import { render, staticRenderFns } from "./SelectTestsReminder.vue?vue&type=template&id=69353110&scoped=true"
import script from "./SelectTestsReminder.vue?vue&type=script&lang=js"
export * from "./SelectTestsReminder.vue?vue&type=script&lang=js"
import style0 from "./SelectTestsReminder.vue?vue&type=style&index=0&id=69353110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69353110",
  null
  
)

export default component.exports